import { themeAtom } from "../../shared/atoms";
import AdminPnlGrid from "../components/debug/AdminPnlGrid";
import AdminPnlSyncModal from "../components/debug/AdminPnlSyncModal";
import AdminPnlTopBar from "../components/debug/AdminPnlTopBar";
import { useAdminPnl } from "../hooks/useAdminPnl";
import { ADMIN_PNL_INITIAL_FILTERS } from "../utils/admin-pnl.constants";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

const AdminPnlDebugPage = () => {
  const theme = useAtomValue(themeAtom);
  const pnl = useAdminPnl();
  const [filters, setFilters] = useState(ADMIN_PNL_INITIAL_FILTERS);
  const busy = pnl.loading || pnl.previewing || pnl.syncing;
  const filtersChanged =
    filters.search !== pnl.appliedFilters.search || filters.reviewerEmail !== pnl.appliedFilters.reviewerEmail;
  return (
    <main
      data-test="admin-pnl-debug-page"
      className={twMerge("flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden", theme.home.tailwind.textDefault)}
    >
      <AdminPnlTopBar
        filters={filters}
        reviewers={pnl.reviewers}
        rowCount={pnl.rows.length}
        disabled={busy}
        onFilters={setFilters}
        onSearch={() => void pnl.refresh(filters)}
      />
      <p className="border-b border-gray-200 px-3 py-2 text-xs opacity-75 dark:border-gray-700">
        Check PnL submissions and sync saved vessel names with the active vessel record.
        {pnl.rows[0] && (
          <>
            {" "}
            Database: <strong>{pnl.rows[0].DATABASE_NAME}</strong>.
          </>
        )}
        {pnl.appliedFilters.reviewerEmail && <> Reviewer checked: {pnl.appliedFilters.reviewerEmail}.</>}
      </p>
      {filtersChanged && (
        <p role="status" className="px-3 py-2 text-sm">
          Apply Search / refresh to update the results and reviewer check.
        </p>
      )}
      {pnl.truncated && (
        <p role="status" className="px-3 py-2 text-sm">
          Showing the first 200 voyages, with submitted PnLs first. Narrow your search to find older records.
        </p>
      )}
      {pnl.loading && (
        <p role="status" className="px-3 py-2 text-sm">
          Loading PnL voyages...
        </p>
      )}
      {pnl.previewing && (
        <p role="status" className="px-3 py-2 text-sm">
          Preparing vessel-name sync preview...
        </p>
      )}
      {pnl.errorMessage && (
        <p role="alert" data-test="admin-pnl-error" className="px-3 py-2 text-sm text-[#BF0002]">
          {pnl.errorMessage}
        </p>
      )}
      {pnl.actionMessage && (
        <p role="status" data-test="admin-pnl-result" className="px-3 py-2 text-sm">
          {pnl.actionMessage}
        </p>
      )}
      <AdminPnlGrid
        rows={pnl.rows}
        disabled={busy || filtersChanged || Boolean(pnl.errorMessage) || Boolean(pnl.preview)}
        onSync={(row) => void pnl.selectSync(row)}
      />
      {pnl.preview && (
        <AdminPnlSyncModal
          preview={pnl.preview}
          syncing={pnl.syncing}
          errorMessage={pnl.modalError}
          onClose={pnl.closePreview}
          onConfirm={() => void pnl.confirmSync()}
        />
      )}
    </main>
  );
};

export default AdminPnlDebugPage;
